import { ITheme, theme } from "../../utils/theme"

export const whiteWrapperStyle = {
  background: 'white',
  p: 1
}

export const redColorStyle = {
  color: (theme: ITheme) => theme.palette.error.light
}

export const greenColorStyle = {
  color: (theme: ITheme) => theme.palette.success.light
}

export const lastUpdateWrepperStyle = {
  mb: 1,
  mt: 2,
  display: 'flex',
  justifyContent: 'space-between',
  '& .MuiTypography-root': {
    color: theme.palette.blue[600]
  }
}

export const tabStyle = {
  fontSize: "16px",
  minHeight: "30px",
  textTransform: "none",
  fontWeight: "bold",
  background: (theme: ITheme) => theme.palette.grey[600],
  '&.Mui-selected': {
    color: (theme: ITheme) => theme.palette.blue[650],
    background: (theme: ITheme) => theme.palette.common.white,
  }
}

export const tabsStyle = {
  minHeight: "30px",
  marginTop: 1,
}